var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "discount-container" },
    [
      _c("h2", [_vm._v("Gültige Rabatte pro Artikel")]),
      Object.keys(_vm.discountsPerArticle).length === 0
        ? _c("div", { staticClass: "no-data" }, [
            _vm._v(
              " Keine gültigen Rabatte für die aktuellen Artikel gefunden. "
            ),
          ])
        : _vm._e(),
      _vm._l(_vm.discountsPerArticle, function (discounts, posId) {
        return _c("div", { key: posId, staticClass: "article-card" }, [
          _c("div", { staticClass: "article-header" }, [
            _c("strong", [_vm._v("Artikel-ID: " + _vm._s(posId))]),
            _c("span", { staticClass: "badge" }, [
              _vm._v(_vm._s(discounts.length) + " Rabatt(e)"),
            ]),
          ]),
          _c(
            "ul",
            { staticClass: "discount-list" },
            _vm._l(discounts, function (discount) {
              return _c("li", { key: discount.name }, [
                _c("span", { staticClass: "discount-name" }, [
                  _vm._v(_vm._s(discount.name)),
                ]),
                _c("span", { staticClass: "discount-value" }, [
                  _vm._v("-" + _vm._s(discount.percentage) + "%"),
                ]),
              ])
            }),
            0
          ),
        ])
      }),
      _c(
        "div",
        { staticClass: "pa-10", staticStyle: { "white-space": "pre" } },
        [
          _vm._v("DEBUG discounts "),
          _c("br"),
          _vm._v(_vm._s(JSON.stringify(_vm.$store.getters.discounts, null, 2))),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }